module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOBAMAAADtZjDiAAAAAXNSR0IB2cksfwAAAB5QTFRFc3Nzc3Nzc3NzAAAAc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzyu9fzQAAAAp0Uk5TbJsRAPyQrD3TIT6OuU4AAABKSURBVHicY2BUNjY2NhJgEAkC0qqODKpuxcbmKUEMRimdxjPclBmMK1yVQtqNGYwtQ9JcJwNpYzWXJGMkGiYOVQfTBzMHZi7UHgCCdRk94hsQDgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./app/images/close_icon.png
// module id = 443
// module chunks = 0